<div class="page-fix-form-wizard-container">
    <ul class="list-unstyled d-flex text-link menu-container">
        <li class="d-flex"
            *ngFor="let v of registeredViews; trackBy: trackByIndex"
            [ngClass]="{'active-underline': view === v }">
            <a role="button"
               (click)="onTabChange(v)"
               tabindex="0"
               class="text-center flex-fill p-2 py-4">
                <span [ngClass]="icon[v.type]" aria-hidden="true"></span>&nbsp;<span>{{v.title}}</span>
            </a>
        </li>
        <li>
            <button class="btn btn-border-radius btn-link close-button" type="button" (click)="dismiss.emit()">
                <span class="sr-only" translate>Close PageCorrect form</span>
                <span class="fas fa-times fa-2x" aria-hidden="true"></span>
            </button>
        </li>
    </ul>
    <div class="mt-3 mx-3 alert alert-notification" *ngIf="showNotification">
        <div class="d-flex flex-wrap">
            <strong class="mr-auto" translate>Fix applied!</strong>
            <div>
                <span class="fa-fw fas fa-clock" aria-hidden="true"></span>
            </div>
        </div>
        <p translate>
            It will take some time before our system will register your changes to PageCorrect
        </p>
    </div>


    <ng-content></ng-content>

    <div class="footer p-4">
        <page-fix-form-wizard-container-footer-options [formValid]="formValid"
                                                       [saving]="saving"
                                                       [removing]="destroying"
                                                       [warning]="warningText"
                                                       [pageFixApplied]="pageFixApplied"
                                                       *ngIf="!pageFixSaved && view?.footer === 'submit'">
        </page-fix-form-wizard-container-footer-options>
        <page-fix-form-wizard-container-footer-go-to-options [pageFixApplied]="pageFixApplied"
                                                             [view]="view"
                                                             *ngIf="!pageFixSaved && view?.footer === 'go-to'">
        </page-fix-form-wizard-container-footer-go-to-options>
        <div class="text-right" *ngIf="pageFixSaved">
            <button class="btn btn-border-radius btn-marine-blue"
                    type="button"
                    (click)="close.emit({ pageFix: pageFix })">
                {{ 'Close' | translate }}
            </button>
        </div>
    </div>
</div>
